import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { PdfTicketContext } from '../white-label/services/pdf-ticket-context.service';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private pdfTicketContext: PdfTicketContext
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.indexOf('googleapis') > 0) {
      return next.handle(request);
    }

    // Página de impressão (Selenium): sem sessão Auth0, o token vem do ticket.
    // O próprio fetch público do ticket (/frontEndOpen/pdf/ticket) roda ANTES de o
    // contexto ser preenchido, então sai sem Authorization — como o backend exige.
    const ticketToken = this.pdfTicketContext.accessToken;
    if (ticketToken) {
      request = request.clone({ setHeaders: { Authorization: `Bearer ${ticketToken}` } });
      return next.handle(request);
    }

    if (this.authService.isAuthenticated()) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authService.accessToken}`
        }
      });
    }
    return next.handle(request);
  }
}
